<template>
    <div class="paymentBox">
        <div class="herder-top">
            <van-icon name="arrow-left" class="ico-left" @click="pushLearning" />
            <span>订单页面</span>
        </div>
            <div class="groupbuy-box" v-if="$route.query.isGroupGood">
                <div class="groupbuy-step">
                    <div class="step-img">
                        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/groupbuy1.png"/>
                    </div>
                    <div class="step-text">选择商品<br>开团/参团</div>
                </div>
                <div class="line"></div>
                <div class="groupbuy-step">
                    <div class="step-img">
                        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/groupbuy2.png"/>
                    </div>
                    <div class="step-text">邀请好友<br>参团支付</div>
                </div>
                <div class="line"></div>
                <div class="groupbuy-step">
                    <div class="step-img">
                        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/groupbuy3.png"/>
                    </div>
                    <div class="step-text">人满成团<br>失败退款</div>
                </div>
            </div>
        <div class="paymentBox-content">
            <div class="payment-content-top _clear">
                <div class="payment-img">
                    <img :src="detailObj.picUrl" alt="" />
                </div>
                <div class="payment-right">
                    <div class="title">{{ detailObj.name }}</div>
                    <!-- <div class="time _clear">
                        <span>时间：</span>
                        <p>
                            {{ goodsList.createTime | formatime }}
                            {{ goodsList.endTime | formatime }}
                        </p>
                    </div> -->
                    <!-- <span class="date"></span> -->
                </div>
            </div>

            <div class="payment-content-bottom">
                <span class="title">商品金额</span>
                <p class="price">
                    <!-- <span class="payment-through" v-if="!handelPaylist.groupOrderTag"
                        >{{ goodsList.basePrice?'¥'+goodsList.basePrice:'' }}</span
                    > -->
                    ¥{{ detailObj.salePrice }}
                </p>
            </div>
            <couponList
                :bottomSafeHeight="0" 
                :couponInfo="couponInfo" 
                @change="onChangeCoupon"
                :checkedCouponUserId="couponUserId"
                :coupon-list="couponListData" />
        </div>
        <div class="payment-footer">
            <div class="footer-box">
                <!-- <p class="footer-title">
                    金额:<span class="footer-price"
                        ><label>¥</label>{{ handelPaylist.realPay }}</span
                    >
                </p> -->
                <p class="footer-title" v-if="isUseCoupon">
                    金额：<span class="footer-price"><label>¥</label>{{ useCouponRealPay }}</span>
                </p>
                <p class="footer-title" v-else>
                    金额：<span class="footer-price"><label>¥</label>{{ detailObj.salePrice }}</span>
                </p>
                <!-- <p class="payment-boutton"><span>立即支付</span></p> -->
                <van-button
                    round
                    type="info"
                    class="payment-boutton"
                    color="#F1430D"
                    :disabled="isDisabledSubmitBtn"
                    @click="handelPay"
                    >去支付</van-button
                >
            </div>
        </div>
        <van-dialog class="orderTip" confirm-button-color="#316FFF" confirm-button-text="订单列表" v-model="showOrderTip" title="" show-cancel-button @confirm="toOrderList" @cancel="showOrderTip=false">
        {{message}}
        </van-dialog>
    </div>
</template>
<script>
import { Toast } from "vant";
import {sensorsMixin} from './mixins/sensors'
export default {
    name: "Payment",
    mixins: [sensorsMixin],
    data() {
        return {
            couponInfo: {},
            couponUserId: '',
            couponListData: [],
            isUseCoupon: false,
            useCouponRealPay: '',
            showOrderTip:false,
            message:'',
            isDisabledSubmitBtn: false, //按钮是否禁用
            money: null, //金额
            handelPaylist: {},
            // goodsList: {},
            getpayNo: "",
            getWx: "",
            code: "",
            token: null,
            wxToken: "",
            wxData: {},
            h5codeUrl: "",
            wxIos: false,
            detailObj:{}
        };
    },
    filters: {
        formatime(val) {
            let year = val ? val.split(" ")[0].split("-")[0] : "";
            let mouth = val ? val.split(" ")[0].split("-")[1] : "";
            let day = val ? val.split(" ")[0].split("-")[2] : "";
            return year + "/" + mouth + "/" + day;
        }
    },
    created() {
        // if(localStorage.getItem('goodsOrderInfo')){
        //     this.handelPaylist = JSON.parse(localStorage.getItem('goodsOrderInfo'));
        //     this.goodsList  = JSON.parse(localStorage.getItem('goodsOrderInfo')).goodsList[0];
        // } else {
        //     this.getgoodsInfo()
        // }
        this.getOrderDetail()
    },
    mounted() {
        this.token = sessionStorage.getItem("WDuserInfo")
            ? JSON.parse(sessionStorage.getItem("WDuserInfo"))
            : null;
        this.getWx = this.WeiXin(); // 判断是否微信 true
        // this.findGoodsById();
        // this.payment(); //调用订单号


        // 监听回退
         if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.pushLearning, false); //false阻止默认事件
          }
    },
    destroyed() {
        window.removeEventListener("popstate", this.pushLearning, false);
    },
    methods: {
        getCouponList() {
            const {salePrice} = this.detailObj;
            return this.$api.account.getUseCoupon({
                goodsId: this.$route.query.goodsId,
                skuNum: 1,
                salePrice,
                source:'h5',
            }).then((res)=>{
                if(res.success) {
                    this.couponListData = res.data;
                }
            })
        },
        onChangeCoupon(value) {
            if(value) {
                if(value == -1) {
                    // 不使用
                    this.couponInfo = {
                        id: -1
                    };
                    this.couponUserId = value;
                    this.isUseCoupon = false;
                } else {
                    this.getCouponPrice(value);
                }
            }
        },
        getCouponPrice(couponUserId) {
            const { id: goodsId, salePrice } = this.detailObj;
            const goodsList = [
                {
                    goodsId,
                    goodsKinds: this.$route.query.goodsKinds,
                    salePrice,
                    skuNum: 1,
                },
            ];
            this.$api.account.useCouponPrice({
                checkGoodsList: goodsList,
                postMoney: 0,
                couponId:couponUserId,
                marketingType: 1,
            }).then((res)=>{
                 if(res.success) {
                    this.isUseCoupon = true;
                    const {orderTotalPrice, favorablePrice} = res.data
                    this.useCouponRealPay = orderTotalPrice;
                    this.couponUserId = couponUserId;
                    this.couponInfo = this.couponListData.filter(v=> v.couponUserId === couponUserId)[0];
                    this.$set(this.couponInfo, 'favorablePrice', favorablePrice);
                } else {
                    this.couponUserId = '';
                }
            })
        },
        pushLearning() {
            if (this.$route.query.hasJumpCashier) {
                // localStorage.removeItem('hasJumpCashier')
                this.$router.push({path: '/'})
            } else {
                this.$router.go(-1);
            }
        },
        //获取商品基本信息  
      getGoodsDetail(){
        return this.$api.courseGoodsDetail.findGoodsDetailById(
          {
            goodsId: this.$route.query.goodsId,
          }
        )
        .then(res=>{
            // console.log(res);
            if(res.code===0){
              this.detailObj = res.data;
              this.getCouponList()
            }
        }).catch(err=>{
            console.log('加载异常', err)
        })
      },
      /**
       * 分销商品详情
       */
      getDistributionGoodsInfo(){
          const params = {
              id:this.$route.query.goodsId
          }
          return this.$api.courseGoodsDetail.getDistributionGoodsInfo({params}).then(res => {
              if(res.code==0){
                this.detailObj = res.data;
                this.getCouponList()
              }
            }).catch(err=>{
                console.log('加载异常', err)
            })
        },
        // getgoodsInfo(){
        //     const data = {
        //         goodsId:this.$route.query.id,
        //         orderSource:2,
        //         orderType:this.$route.query.orderType,
        //     }
        //     this.$api.courseGoodsDetail.order({data}).then(res => {
        //         this.handelPaylist = res.data || null;
        //         this.goodsList = res.data.goodsList[0]
        //     })
        // },
        // findGoodsById() {
        //     let params = {
        //         id: this.$route.query.id ? this.$route.query.id : "" //this.$route.query.id
        //     };
        //     this.$api.home.findGoodsById({ params }).then(data => {
        //         this.goodsList = data.data;
        //         console.log(this.goodsList)
        //     });
        // },
        // payment() {
        //     this.$api.home
        //         .placeOrder({
        //             // 调用订单号
        //             data: {
        //                 goodsId: this.$route.query.id
        //                     ? Number(this.$route.query.id)
        //                     : "",
        //                 orderSource: 2,
        //                 agentId: localStorage.getItem('detailAgentId') || ''
        //             }
        //         })
        //         .then(res => {
        //             this.handelPaylist = res.data;
        //         });
        // },
        WeiXin() {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                    navigator.userAgent
                        .toLowerCase()
                        .indexOf("micromessenger") !== -1
                );
            };
            if (isWeiXin()) {
                return true;
            } else {
                return false;
            }
        },
        // isIOS() {
        //     // 判断是iOS 还是安卓
        //     let u = navigator.userAgent;
        //     let app = navigator.appVersion;
        //     // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        //     let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        //     if (isIOS) {
        //         this.wxIos = true;
        //     }
        // },
        getLogParams() {
          const {branchId: aff_institution_id = '', branchName: aff_institution_name = ''} = this.detailObj.mallTrainingGoodsDetail || {};
          const {goodsKinds = ''} = this.$route.query;
          const {name = '', salePrice = '', basePrice = '',id=''} = this.detailObj || {}
          const [
            commodity_firstcate = '', 
            commodity_secondcate = '', 
            commodity_thirdcate = ''
          ] = this.detailObj.mallTrainingGoodsDetail.categoryPath || [];
          return {
              commodity_id: id,
              goodsKinds: goodsKinds,
              aff_institution_id: String(aff_institution_id),
              aff_institution_name,
              commodity_firstcate,
              commodity_secondcate,
              commodity_thirdcate,
              commodity_name: name,
              original_price: basePrice,
              current_price: this.handelPaylist.realPay,
          }
        },
        handelPay() {
            // if(this.$route.query.orderNo){
            //     this.onPayment();
            // }else{
                const {id: goodsId,salePrice} = this.detailObj;
                const orderSource = '2';

                let realPay,totalMoney;
                totalMoney = salePrice;
                realPay = salePrice;
                if(this.couponUserId && this.couponUserId > -1) {
                    // 使用优惠券
                    realPay = this.useCouponRealPay;
                }
                var data = {
                        activityGroupId:'',
                        totalMoney:this.$route.query.isGroupGood==1&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice,
                        orderSource:2,
                        orderType:this.$route.query.goodsKinds == 2 ? 4 : this.$route.query.goodsKinds==1?localStorage.getItem('detailAgentId')?3:1:null,
                        agentId: localStorage.getItem('detailAgentId') || '',
                        distributionUserId:this.$route.query.distributionUserId || '',
                        shareUserInfo:sessionStorage.getItem('recommendUserUcode')?sessionStorage.getItem('recommendUserUcode'):'',
                        goodsList:[{
                            goodsId:this.$route.query.goodsId,
                            goodsKinds:this.$route.query.goodsKinds,
                            num:1,
                            promotionId:'',
                            salePrice:this.$route.query.isGroupGood==1&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice
                        }],
                        couponNo: this.couponUserId && this.couponUserId > -1 ? this.couponUserId :'',
                        realPay:this.couponUserId && this.couponUserId > -1?realPay:(this.$route.query.isGroupGood==1&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice),
                        platformActivityRuleItemId:this.$route.query.isGroupGood==1&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.activityRuleItemId:'',
                        platformSecKillActivityItemId:!this.$route.query.isGroupGood&&this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.secKillActivityItemId:''
                    }
                if(this.$route.query.isGroupGood==2){
                    data = {
                        activityGroupId:this.$route.query.activityGroupId,
                        totalMoney:this.detailObj.shoppingGroup.price,
                        orderSource:2,
                        orderType:this.$route.query.goodsKinds == 2 ? 4 : this.$route.query.goodsKinds==1?localStorage.getItem('detailAgentId')?3:1:null,
                        agentId: localStorage.getItem('detailAgentId') || '',
                        distributionUserId:'',
                        shareUserInfo:'',
                        goodsList:[{
                            goodsId:this.$route.query.goodsId,
                            goodsKinds:this.$route.query.goodsKinds,
                            num:1,
                            promotionId:'',
                            salePrice:this.detailObj.shoppingGroup.price
                        }],
                        realPay:this.couponUserId && this.couponUserId > -1?realPay:this.detailObj.shoppingGroup.price,
                        platformActivityRuleItemId:this.$route.query.platformActivityRuleItemId
                    }
                }
                this.$api.courseGoodsDetail.ordertoc({data}).then(async (res)=>{
                    // if(res.success) {
                        // localStorage.setItem('goodsOrderInfo',JSON.stringify(res.data));
                        if(res.code==0){
                            sessionStorage.removeItem('recommendUserUcode');
                            if(res.data.placeOrderSuccess && res.data.realPayPrice > 0) {
                                this.handelPaylist = res.data;
                                console.log(res.data);
                                this.onPayment()
                            } else {
                                if(res.data.url) {
                                window.open(res.data.url, '_self')
                                } else {
                                this.$router.go(-1)
                                }
                            }
                        }else if(res.code==50001){
                            this.message = res.message;
                            this.showOrderTip = true;
                        }else{
                            Toast({
                                message: res.message,
                                duration: 2000
                            })
                        }
                    // }
                })
            // }
        },
        //跳转订单列表
      toOrderList(){
        this.$router.push({
          path:'/orderpage',
          query:{
            backPath:'/'
          }
        })
      },
        onPayment(){
            this.$api.home
                .prePayOrder({
                    // 调用订单号
                    data: {
                        orderId: this.handelPaylist.id,
                        orderNo: this.handelPaylist.orderNo,
                        totalMoney: this.handelPaylist.realPay,
                        payInfoDesc: "",
                        scene: this.getWx ? 101 : 4,
                        agentId: localStorage.getItem('detailAgentId') || ''

                    }
                })
                .then(async(res) => {
                    if (res.message === "success") {
                        this.onTrack('submit_order_success', {
                            buy_type:this.detailObj.isFree?'免费':'付费',
                            order_id:this.handelPaylist.orderNo
                        });
                        let url  = ''
                        let locationHref = window.location.href
                        if (locationHref.includes('testing')) {
                            url = 'pay.testing3.wdeduc.com'
                        } else if (locationHref.includes('fat')) {
                            url = 'pay.fat.wdeduc.com'
                        } else if (locationHref.includes('uat')) {
                            url = 'pay.uat.wdeduc.com'
                        } else  {
                            url = 'pay.wdeduc.com'
                        }
                        // 跳转支付系统，在返回使用的标记
                        // localStorage.setItem('hasJumpCashier', 1)
                        const successBackUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                        const backUrl = window.location.origin+ `/gongxin_payment?goodsId=${this.$route.query.goodsId}&isGroupGood=${this.$route.query.isGroupGood}&backUrl=`;
                        const CSuccessBackUrl = window.location.origin + `/grouppurchasedetail?orderNo=${this.handelPaylist.orderNo}`;
                        let mineMenu = sessionStorage.getItem('mineMenu')
                        if (!mineMenu) {
                          mineMenu = '/saccount'
                        }
                        const data = {
                            key: this.handelPaylist.orderNo,
                            value: JSON.stringify({
                                orderNo: this.handelPaylist.orderNo,
                                organ: localStorage.getItem("organ"),
                                token: localStorage.getItem("token"),
                                actor: localStorage.getItem("actor"),
                                branch: localStorage.getItem("branch"),
                                backUrl: backUrl,
                                id: this.$route.query.id,
                                goodsId:this.$route.query.goodsId,
                                goodsKinds:this.$route.query.goodsKinds,
                                referId: this.detailObj.referId,
                                orderType: this.handelPaylist.orderType,
                                successBackUrl: successBackUrl,
                                CSuccessBackUrl: this.handelPaylist.groupOrderTag?CSuccessBackUrl:(window.location.origin+`/orderpage?backPath=${mineMenu}`)
                            })
                        }

                        let result = await this.$api.orderPage.jumpPaySaveParams(data)
                        // alert(result.code+'----'+this.handelPaylist.orderNo)
                        // if(result.success) {
                        //     window.location.href = `https://${url}/cashier?orderNo=${this.handelPaylist.orderNo}`
                        // }

                        window.location.href =
                            "https://" +
                            `${url}` +
                            "/cashier?orderNo=" +
                            `${this.handelPaylist.orderNo}` +
                            "&organ=" +
                            localStorage.getItem("organ") +
                            "&token=" +
                            localStorage.getItem("token") +
                            "&actor=" +
                            localStorage.getItem("actor") +
                            "&branch=" +
                            localStorage.getItem("branch") +
                            "&backUrl=" +
                            window.location.origin +
                            "&id=" +
                            this.$route.query.id + 
                            "&orderType=" +
                            this.handelPaylist.orderType +
                            '&successBackUrl=' + successBackUrl
                    }
                });
        },
           // 查询订单详情
        async getOrderDetail() {
            // if(this.$route.query.orderNo){
            //     let orderNo = this.$route.query.orderNo
            //     let res = await this.$api.orderPage.getOrderByNo(orderNo)
            //     this.handelPaylist = res.data || null;
            //     // this.goodsList = res.data.goodsList[0]
            //     // this.getOrderStatus()
            // }
            if(this.$route.query.goodsKinds == 2){
                await this.getDistributionGoodsInfo();// 分销商品详情
            }else {
                await this.getGoodsDetail();// 商品详情
            }
            // this.intervalId = setInterval(() => {
            //     this.getOrderStatus()
            // }, 3000)

        },
        //  查询订单状态
        async getOrderStatus() {
            
            let orderNo = this.$route.query.orderNo
            let res = await this.$api.orderPage.getOrderStatus(orderNo)
            if(res.data.orderStatus !== 0 ) {
                // 
                // clearInterval(this.intervalId)
                if(res.data.url) {
                    window.open(res.data.url, '_self')
                } 
                // else {
                //     this.$router.replace({
                //         path: '/goodsList'
                //     })
                // }
            }

        },
    }
};
</script>
<style scoped lang="less">
@import url("../asset/css/payment");
</style>
